<template>
  <i :class="icon" :style="hasColor ? 'color:' + hasColor : ''"></i>
</template>

<script>
export default {
  name: 'icon',
  props: {
    /**
     * Structure to define an icon...
     *
     * {
     *   icon: 'fas font-awesome-icon-etc',
     *   color: 'orange'
     * }
     *
     * ICON is REQUIRED and contains ALL the classes that need to
     *   be included on a font awesome icon for the HTML markup
     *   to work.
     * COLOR is OPTIONAL and can contain any CSS-valid color code.
     */
    i: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon() {
      return this.$props.i.icon
    },
    hasColor() {
      return this.$props.i.color ? this.$props.i.color : false
    }
  }
}
</script>
